<template>
  <div>
    <a-select
      :loading="loadingList"
      allowClear
      show-search
      :filter-option="false"
      @search="onSearchSelect"
      @change="handleInput"
      v-bind="{
        ...selectProps,
        defaultValue: selectProps.defaultValue
          ? selectProps.defaultValue
          : undefined,
      }"
    >
      <a-spin v-if="loadingList" slot="notFoundContent" size="small" />
      <a-select-option
        v-if="!loadingList && datas.length > 0"
        disabled
        key="disabled"
      >
        Enter to search
      </a-select-option>
      <a-select-option v-for="item in datas" :key="item.id">
        {{ item.name }}
      </a-select-option>
    </a-select>
  </div>
</template>
<script>
import query from "./constant/query";
import debounce from "lodash/debounce";
export default {
  props: {
    selectProps: {
      type: Object,
      default() {
        return {};
      },
    },
    isGetDataCreated: {
      type: Boolean,
      default: true,
    },
    initialDatas: {
      type: Array,
      default() {
        return [];
      },
    },
    variablesQuery: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    this.onSearchSelect = debounce(this.onSearchSelect, 500);
    return {
      loadingList: false,
      datas: [],
      filter: {},
    };
  },
  model: {
    event: "change",
  },

  methods: {
    handleInput(value) {
      this.$emit("change", value);
    },
    onSearchSelect(input, option) {
      this.datas = [];
      this.$set(this.filter, "query", input);
      this.onGetAllPosition();
    },
    onGetAllPosition() {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getAllPosition,
          fetchPolicy: "no-cache",
          variables: {
            status: "ACTIVE",
            query: this.filter.query,
            limit: 20,
            page: 1,
            ...this.variablesQuery,
          },
        })
        .then(({ data }) => {
          if (data?.getAllPosition?.length >= 0) {
            if (this.initialDatas?.length > 0) {
              const uniqueInitialDatas = [];
              for (let i in this.initialDatas) {
                const item = this.initialDatas[i];
                const find = data.getAllPosition.find((e) => e.id === item.id);
                if (!find) {
                  uniqueInitialDatas.push(item);
                }
              }
              this.datas = [...data.getAllPosition, ...uniqueInitialDatas];
            } else {
              this.datas = [...data.getAllPosition];
            }
            this.loadingList = false;
          }
        })
        .catch((error) => {
          console.error("Error get list", error);
        });
    },
  },
  created() {
    if (this.isGetDataCreated && this.initialDatas?.length > 0) {
      throw new Error(
        "Cannot exits the same time isGetDataCreated and initialDatas"
      );
    }
    if (this.isGetDataCreated) {
      this.onGetAllPosition();
    }

    if (this.initialDatas?.length > 0) {
      this.datas = [...this.initialDatas];
    } else {
      this.onGetAllPosition();
    }
  },
};
</script>
